<template>
	<div class="incenters">
		<!-- style="border: 1px solid red;" -->
		<div>
			<!-- <Commonbtn title="导出"></Commonbtn> -->
			<div class="topstate" v-for="(item , index) of state" :key="index" :class="[{ 'ativte' : onchage == index}]"
				@click="clicktab(index)">
				{{ item.title }}
			</div>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth" v-if="tableflag" style="overflow-x: scroll;">
			<Commontable :rowhe="false" colnum=7 :loadingTable="loadingTable" :tableData="tableDataDetail"
				:headerData="headerData" height="100%"></Commontable>
		</div>
		<div class="TableWidth" v-if="tableflags">
			<Commontable :CusFlag="CusFlag" colnum=3 :loadingTable="loadingTable" :tableData="tableDataUnique"
				height="100%" @InvDel="InvDel"></Commontable>
		</div>
	</div>
</template>

<script>
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import {
		SaleBillDetail,
		SaleBillDetailUnique,
		CusType,
		SaleBillDeleteInvListImg
	} from '@/api/home'
	export default {
		components: {
			Commontable,
			Commonbtn,
		},
		props: ['sbmid', 'tableDataUnique', 'tableDataDetail'],
		data: function() {
			return {

				loadingTable: false,
				tableData1: [],
				tableData: [],
				headerData: [{
						prop: 'id',
						label: '序号',
						columnwidth: 50
					},
					{
						prop: 'InvAddCode',
						label: '产品代码',
						columnwidth: 170
					},
					{
						prop: 'InvName',
						label: '存货名称',
						columnwidth: 133
					},
					{
						prop: 'Batch',
						label: '批号',
						columnwidth: 110
					},
					{
						prop: 'Quantity',
						label: '数量',
						columnwidth: 82
					},
					{
						prop: 'NatSum',
						label: '本币价税合计',
						columnwidth: 105,
					},
					{
						prop: 'NatTaxPrice',
						label: '本币税额',
						columnwidth: 105,
					},
					{
						prop: 'NatMoney',
						label: '本币去税金额',
						columnwidth: 105,
					},

					{
						prop: 'TaxRate',
						label: '税率',
						columnwidth: 53,
					},
					{
						prop: 'ExchangeRate',
						label: '汇率',
						columnwidth: 53,
					},
					{
						prop: 'TaxUnitPrice',
						label: '原币含税单价',
						columnwidth: 105,
					},
					{
						prop: 'VouCode',
						label: '经销商出库单号',
						columnwidth: 146,
					},
					{
						prop: 'CorCode',
						label: '对应蓝票号',
						columnwidth: 146,
					}, {
						prop: "BRedInvoiceNo",
						label: "红字发票号",
						columnwidth: 150,
					},
					{
						prop: 'VouDCode',
						label: '来源单据明细行号',
						columnwidth: 134,
					},
					{
						prop: 'ValiDate',
						label: '有效期至',
						columnwidth: 102,
					},
					{
						prop: 'UnitPrice',
						label: '原币单价',
						columnwidth: 105,
					}
				],
				state: [{
						title: '明细'
					},
					{
						title: '发票图片'
					}
				],
				onchage: 0,
				CusFlag: null,
				tableflag: true,
				tableflags: false,
				tableDataSaleBillDetail: [],
				tableDataSaleBillDetailUnique: [],
			}
		},
		created() {},
		mounted() {
			this.SaleBillDetail()
			this.CusType()
		},
		methods: {
			// 明细
			async SaleBillDetail() {
				let {
					data,
					code
				} = await SaleBillDetail({
					sbmid: this.sbmid
				})
				if (code == 0) {
					this.tableDataDetail = data
				}
			},
			// 发票照片
			async SaleBillDetailUnique() {
				let {
					data,
					code
				} = await SaleBillDetailUnique({
					sbmid: this.sbmid
				})
				if (code == 0) {
					this.tableDataUnique = data
					console.log(1111, data);
				}
			},
			// 销货清单图片删除 
			async InvDel(SBPDID) {
				let {
					code,
					data,
					message
				} = await SaleBillDeleteInvListImg({
					ImgID: SBPDID
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: "删除成功"
					})
					this.SaleBillDetailUnique()
				} else {
					this.$message({
						type: "error",
						message: message
					})
				}
			},
			async CusType() {
				let {
					data,
					code
				} = await CusType({})
				if (code == 0) {
					if (data.CusType == "") {
						this.CusFlag = 1
					}
				}
			},
			clicktab(index) {
				if (index == 0) {
					this.tableflag = true
					this.tableflags = false
					this.SaleBillDetail()
				}
				if (index == 1) {
					this.tableflag = false
					this.tableflags = true
					this.SaleBillDetailUnique()
				}
				if (this.onchage != index) {
					this.onchage = index
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.ativte {
		border: 1px solid red;
		color: #e71d43;
		background-color: #fce8ec;
		transition: 0.2s linear;
	}

	.incenters {
		height: 100%;
		font-family: "微软雅黑";
		background-color: #fff;
		width: 980px;
		margin-top: 10px;
		padding-bottom: 10px;
		padding-top: 2px;
		box-shadow: 0px 1px 4px 0px rgb(0 0 0 / 10%);

		div {
			margin-left: 8px;
			margin-right: 8px;
			margin-top: 5px;
			margin-bottom: 5px;
			// width: 100%;
		}
	}

	.topstate {
		width: 100px;
		height: 32px;
		font-size: 14px;
		border: 1px solid #e6e6e6;
		line-height: 32px;
		text-align: center;
		cursor: pointer;
		display: inline-block;
		user-select: none;
	}
</style>